module.exports = __webpack_public_path__ + "img/aero-shot-4.a426f06a.webp";